/// <amd-module name="Build/Common/Artifacts/providers/SymbolStore" />
import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes } from 'Common';
export class SymbolStore extends Base {
    public getKey() {
        return BuildArtifactTypes.SymbolStore;
    }
}
